module.exports = __webpack_public_path__ + "media/customizations/experiencesevenoaks/logo-new-101bdbde2f6137c977e65c80d87219b9.png";